import * as yup from 'yup';

const validationSchema = yup.object({
  identifier: yup.string().required('Prisijungimo vardas yra privalomas'),
  password: yup.string().required('Slaptažodis yra privalomas'),
});

export default validationSchema;
